import React from "react";
import {CircleUser} from 'lucide-react';
import { useT } from "@/lib/config/useTranslations";
import { useLanguage } from "@/lib/config/useLanguage";

export default function BtnAccount({ href } = {}) {
    const { t } = useT();
    const { localizePath } = useLanguage();
    const label = t('common.account');

    return (
        <a
            href={href || localizePath('/profile/')}
            aria-label={label}
            title={label}
            className="rounded-xl flex flex-row items-center gap-2 bg-white/10 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-white/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
            <CircleUser className="text-white" aria-hidden="true"/>
            <span className="sr-only">{label}</span>
        </a>
    )
}
